module.exports = __webpack_public_path__ + "static/logo-0ab82de8af8196ff69188f1a27f8ff62.png";